import React, { Component } from 'react';
import './css/About.scss';


class About extends Component {
  render() {
    return (
      <div>
          <h1>404 bitch</h1>
      </div>
    );
  }
}

export default About;
